import { Injectable, isDevMode, makeStateKey, TransferState } from '@angular/core';

import { CreditAppStateMock } from '../../mocks/app-state.mock';

@Injectable({
  providedIn: 'root'
})
export class StateService {
  state: any = null;

  constructor(private transferState: TransferState) {
    if (isDevMode()) {
      this.state = CreditAppStateMock;
      this.transferState['store'] = this.state;
      return;
    } else {
      this.readState();
    }
     if (!this.transferState['store']['Sitecore']) {
      this.transferState['store'] = this.state;
    }
  }

  readState() {
    const element = (document.getElementById(
      'dt-credit-app-state'
    ) as HTMLInputElement) || { innerText: '' };
    this.state = JSON.parse(
      element.innerText !== ''
        ? element.innerText
            .replace(new RegExp('&q;', 'g'), '"')
            .replace(new RegExp('&a;', 'g'), '&')
            // tslint:disable-next-line:quotemark
            .replace(new RegExp('&s;', 'g'), "'")
            .replace(new RegExp('&l;', 'g'), '<')
            .replace(new RegExp('&g;', 'g'), '>')
        : '{}'
    );
  }

  deleteState() {
    const element = document.getElementById('dt-credit-app-state') as HTMLInputElement;
    element.innerText = '';
  }

  get(key: string): any {
    const transferKey = makeStateKey(key);
    return this.transferState.get(transferKey, null as any);
  }

  remove(key: string) {
    const transferKey = makeStateKey(key);
    return this.transferState.remove(transferKey);
  }

  found(key: string) {
    const transferKey = makeStateKey(key);
    return this.transferState.hasKey(transferKey);
  }

  cleanupAngularModal(targetContainerId: any = 'pre-qual') {
    if (!window.location.href.includes('autonation')) {
      const wrapper : any = document.getElementById(targetContainerId);
      if (wrapper) wrapper.remove();

      const overlay = document.getElementById('custom-injected-overlay');
      if (overlay) overlay.remove();

      const modal = document.getElementById('custom-injected-modal');
      if (modal) modal.remove();

      document.querySelectorAll('link[rel="stylesheet"]').forEach((link: any) => {
        if (link.href && (link.href.includes('autonation.com') || link.href.includes('localhost'))) {
          console.log('Removing stylesheet:', link.href);
          link.remove();
        }
      });

      const angularStyleMarkers = ['_ng', 'ngcontent', 'nghost'];
      document.querySelectorAll('style').forEach(style => {
        const content = style.innerText || '';
        const isAngularStyle = angularStyleMarkers.some(marker =>
          content.includes(marker)
        );
        if (isAngularStyle) {
          console.log('Removing Angular inline style:', style);
          style.remove();
        }
      });

      document.querySelectorAll('script').forEach(script => {
        if (script.src && (script.src.includes('autonation.com') || script.src.includes('localhost'))) {
          console.log('Removing script:', script.src);
          script.remove();
        }
      });

      console.log('Cleaned up injected Angular app.');
    } else {
      console.log('Skipped cleanup — on autonation domain.');
    }
  }
}
